export default __webpack_public_path__ + "static/media/Stats_deed_2015-2016.8de7f172.pdf";